module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/4-bg-2ba649cdb13992cc0ec7e694af8386df.png";